import { customerService } from "../../services/customerService";
import { sourceSystemService } from "../../services/sourceSystemService";

export type IncidentCustomerSource = {
  customer?: { id?: string; name?: string } | null;
  customerId?: string;
  sourceSystemId?: string;
  sourceSystem?: { id?: string } | null;
};

export function readIncidentCustomerName(incident: IncidentCustomerSource | null | undefined): string | undefined {
  const name = incident?.customer?.name?.trim();
  if (name) {
    return name;
  }
  const id = incident?.customerId?.trim() || incident?.customer?.id?.trim();
  return id || undefined;
}

export async function resolveIncidentCustomerName(
  incident: IncidentCustomerSource | null | undefined,
): Promise<string | undefined> {
  if (!incident) {
    return undefined;
  }

  const embedded = incident.customer?.name?.trim();
  if (embedded) {
    return embedded;
  }

  const customerId = incident.customerId?.trim() || incident.customer?.id?.trim();
  if (customerId) {
    try {
      const customer = await customerService.getCustomer(customerId);
      return customer?.name?.trim() || customerId;
    } catch {
      return customerId;
    }
  }

  const sourceSystemId = incident.sourceSystemId?.trim() || incident.sourceSystem?.id?.trim();
  if (!sourceSystemId) {
    return undefined;
  }

  try {
    const sourceSystem = await sourceSystemService.getSourceSystem(sourceSystemId);
    const linkedCustomerId =
      typeof sourceSystem?.customerId === "string" ? sourceSystem.customerId.trim() : "";
    if (!linkedCustomerId) {
      return undefined;
    }
    const customer = await customerService.getCustomer(linkedCustomerId);
    return customer?.name?.trim() || linkedCustomerId;
  } catch {
    return undefined;
  }
}
